import { render } from "./SifreUnuttum.vue?vue&type=template&id=681f284d&scoped=true"
import script from "./SifreUnuttum.vue?vue&type=script&lang=js"
export * from "./SifreUnuttum.vue?vue&type=script&lang=js"

import "./SifreUnuttum.vue?vue&type=style&index=0&id=681f284d&scoped=true&lang=css"

import exportComponent from "C:\\Users\\cosku\\OneDrive\\Masaüstü\\DiyetisyenYagmurDemir\\GT Yönetim Sistemi - Kopya\\Yönetim Sistemi - Frontend\\FrontEnd\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-681f284d"]])

export default __exports__